import Vuex from 'vuex';
import Vue from 'vue';

import search from '@/Modules/search/Search';

Vue.use(Vuex);

const filterSearchInputs = Array.from(
  document.getElementsByClassName('js-filter-search-input'),
);

function updateSearchFields(updatedInput) {
  const newValue = updatedInput.value;
  filterSearchInputs
    .filter(input => input !== updatedInput)
    .forEach(input => (input.value = newValue));
}

if (filterSearchInputs.length) {
  const responseObject = search();

  let updateTimeout = null;
  const updateRequestDebounced = (args) => {
    if (updateTimeout) {
      window.clearTimeout(updateTimeout);
    }
    updateTimeout = window.setTimeout(() => {
      responseObject.updateRequest(args);
    }, 800);
  };

  filterSearchInputs.forEach((input) => {
    input.addEventListener('keyup', () => {
      updateRequestDebounced({
        pageNumber: 1,
        query: input.value,
      });
      updateSearchFields(input);
    });
  });
}

export default {};
